import { render, staticRenderFns } from "./VoiceMail.vue?vue&type=template&id=4e9c7583"
import script from "./VoiceMail.vue?vue&type=script&lang=ts"
export * from "./VoiceMail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports